import './style.css'
import * as dat from 'lil-gui'
import * as THREE from 'three'

import {SVGLoader} from 'three/examples/jsm/loaders/SVGLoader.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
// import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js'

import * as Stats from 'stats-js'
import BezierEasing from 'bezier-easing';

import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'

import chrommaticAberrationFragmentShader from './shaders/PostShaderFragment.glsl'

import logoFragmentShader from './shaders/logoFragmentShader.glsl'

import { Reflector } from 'three/examples/jsm/objects/Reflector.js'

import { HorizontalBlurShader } from 'three/examples/jsm/shaders/HorizontalBlurShader.js';
import { VerticalBlurShader } from 'three/examples/jsm/shaders/VerticalBlurShader.js';
import { ShaderMaterial } from 'three'

const stats = new Stats();
stats.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom

let statsDom = stats.dom 
document.body.appendChild( statsDom);
/**
 * Base
 */
// Debug
const debugObject = {}

const gui = new dat.GUI({
    width: 200
})

const getPixelRatio = () => {


     return Math.min(window.devicePixelRatio, 2)

}
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
debugObject.clearColor = '#0d0d0d'
debugObject.clearColor = '#1A1E24'
scene.background = new THREE.Color(debugObject.clearColor)

scene.fog = new THREE.Fog(new THREE.Color(debugObject.clearColor),
        40,
        60);
/**
 * Loaders
 */
// Texture loader
const textureLoader = new THREE.TextureLoader()
const cubeTextureLoader = new THREE.CubeTextureLoader()


// // Draco loader
// const dracoLoader = new DRACOLoader()
// dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader()
// gltfLoader.setDRACOLoader(dracoLoader)

// FBX loader
const fbxLoader = new FBXLoader()

// File loader 
const fileLoader = new THREE.FileLoader()
/**
 * Materials
 */

// const matcapTexture = textureLoader.load('matcap.png')
// matcapTexture.encoding = THREE.sRGBEncoding

const bakeTexture = textureLoader.load('lightmaps/baked2.png')
const reflectiveFloorTexture = textureLoader.load('lightmaps/baked2-green.png')

const bakeTextureSeating = textureLoader.load('lightmaps/baked_seating2.png')
const bakeTextureVarious = textureLoader.load('lightmaps/various.png')
const logoGradient = textureLoader.load('gradient.png')
const bannersTexture = textureLoader.load('banners.png')

const facesTexture = textureLoader.load('faces_atlas.jpg')
reflectiveFloorTexture.flipY = false
facesTexture.flipY = false
bannersTexture.flipY = false
bakeTexture.flipY = false
bakeTextureSeating.flipY = false
bakeTextureVarious.flipY = false

// bakeTexture.encoding = THREE.LinearEncoding
facesTexture.encoding = THREE.sRGBEncoding

const bakeMat = new THREE.MeshBasicMaterial({
    map: bakeTexture,
    side: THREE.DoubleSide
})
const bakeMat2 = new THREE.MeshBasicMaterial({
    map: bakeTextureSeating
})

const bakeMat3 = new THREE.MeshBasicMaterial({
    map: bakeTextureVarious
})

const bannersMat = new THREE.MeshBasicMaterial({
    map: bannersTexture
})
 const wireframe = new THREE.MeshBasicMaterial({
     wireframe: true
 })
 const facesMat = new THREE.MeshBasicMaterial({
   map: facesTexture,
   side: THREE.DoubleSide
})
/**
 * Model
 */


const emissiveWhite = new THREE.MeshBasicMaterial({color: 'white'})
const emissiveBlue = new THREE.MeshBasicMaterial({color: '#3C91F6'})


//const logoMat = new THREE.MeshStandardMaterial({map: logoGradient, roughness: 0.5})

const light = new THREE.PointLight(0xffffff, 2, 20)
light.position.set(0, 6, 3)
scene.add(light)

const light2 = new THREE.AmbientLight(0xffffff, 1)
scene.add(light2)

// const lightHelper = new THREE.PointLightHelper(light)
// scene.add(lightHelper)

let emotesPositions = Array()
let emotesNames = Array()
let emotesGeometry = {}
let personPosition = new THREE.Vector3()

let personObject;
gltfLoader.load(
    'stage5.glb', 
    (gltf)=>{

        gltf.scene.traverse(
            (child)=>{

        
                child.material = wireframe

                if (child.name == 'the_stage_1') {
                    child.material = bakeMat
                } 
                
                if (child.name == 'stage_el_3') {
                    child.material = bakeMat
                }

                if (child.name == 'stage_walls') {
                    child.material = bakeMat
                }

                if (child.name.startsWith('emissive')) {
                    child.material = emissiveWhite
                }
                if (child.name.startsWith('emissive_blue')) {
                    child.material = emissiveBlue
                }

                if (child.name.startsWith('seat')) {
                    console.log('name starts with seat')
                    child.material = bakeMat2
                }                
                if (child.name.startsWith('various')) {
                    child.material = bakeMat3
                }

                if (child.name === 'person') {
                    child.material = personMatcapMat
                    personPosition = child.position
                    personObject = child
                }
                
                if (child.name === 'head') {
                    if (window.location.hash === '#uncannyvalley') {

                        child.material = headMaterial
                    } else {
                        child.material = personMatcapMat
                    }

                    

                } 
                
                if (child.name.startsWith('suit')) {
                    if (window.location.hash === '#uncannyvalley') {
                        child.material = suitMaterial
                    } else {
                    
                        child.material = personMatcapMat
                    }
                }
                if (child.name === 'banners') {
                    child.material = bannersMat
                }

                if (child.name  === 'logo_unwrapped') {
                    child.material = logoMat
                }
                if (child.name  === 'faces') {
                    child.material = facesMat
                }


                if (child.name === 'the_mirror') {
                    child.visible = false
                }
                
                if (child.name.startsWith('positions_for_emotes')) {
                    child.visible = false

                    emotesPositions.push(child.position)
                }

                if (child.material == wireframe && !child.name.startsWith('positions_for_emotes')) {
                    console.log(child.name)
                }
            }
        )
        scene.add(gltf.scene)
        setUpEmotes()

        // personObject.visible = false
        // const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256 );
        // cubeRenderTarget.texture.type = THREE.HalfFloatType;
        // const cubeCamera = new THREE.CubeCamera( 1, 10, cubeRenderTarget );
        // cubeCamera.position.set(0, 1, 0)

        // const cameraHelper = new THREE.Mesh(new THREE.BoxGeometry(0.1,0.1,0.1), new THREE.MeshBasicMaterial({color: 'red'}))
        // cameraHelper.position.copy( cubeCamera.position)
        // scene.add(cameraHelper)
        // personMatcapMat.envMap = cubeRenderTarget.texture
        // cubeCamera.update( renderer, scene );
        // personObject.visible = true
    }
)


let emotesParticles;
const emotesTexture = textureLoader.load('emotes.png', ()=>{
    if (emotesParticles) {
        emotesParticles.material.needsUpdate = true
    }


})
emotesTexture.flipY = false

const nosieTexture = textureLoader.load('nosieTexture.png')
nosieTexture.generateMipmaps = false

const emotesMaterial = new THREE.ShaderMaterial({
    uniforms: {
        uPixelRatio: {value: getPixelRatio()},
        uSize: {value: 512},
        uTime: {value: 0},
        uTexture: {value: emotesTexture},

        fogColor:    { type: "c", value: scene.fog.color },
        fogNear:     { type: "f", value: scene.fog.near },
        fogFar:      { type: "f", value: scene.fog.far }
    },
    transparent: true,
    blending: THREE.AdditiveBlending,
    depthWrite: false,
    vertexShader: 
    `
    ${THREE.ShaderChunk[ "common" ]}
    ${THREE.ShaderChunk[ "fog_pars_vertex" ]}
    uniform float uPixelRatio;
    uniform float uSize;
    uniform float uTime;

    uniform sampler2D nosieTexture;

    attribute vec2 aRandom;

    varying vec2 vRandom;
    varying float vHeight;

    void main() {

        vRandom = aRandom;
        vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );

        vec4 modelPosition = modelMatrix * vec4(position, 1.0);
        
        modelPosition.y += mod(uTime * 0.1 + aRandom.r * 10., 0.5) * 18.;

        vec4 viewPosition = viewMatrix * modelPosition;
        vec4 projectionPosition = projectionMatrix * viewPosition;
        ${THREE.ShaderChunk[ "fog_vertex" ]}

        vHeight = modelPosition.y;
        gl_Position = projectionPosition;
        gl_PointSize = uSize * uPixelRatio / (modelPosition.y + 1.) * 2.;
        //gl_PointSize = uSize * uPixelRatio * modelPosition.y * 0.25;
        gl_PointSize *= (1.0 / -viewPosition.z);
    }
    `,

    fragmentShader: 
    `
        varying vec2 vRandom;

        ${THREE.ShaderChunk[ "common" ]}
        ${THREE.ShaderChunk[ "fog_pars_fragment" ]}

        uniform sampler2D uTexture;
        varying float vHeight;
        void main() {

            float coordX = round(vRandom.x);
            float coordY = round(vRandom.y);
            
            float distanceToCenter = distance(gl_PointCoord, vec2(0.5));

            vec4 color = texture(uTexture, vec2(gl_PointCoord.x * 0.5 + coordX * 0.5, gl_PointCoord.y * 0.5 + coordY * 0.5));
            
            gl_FragColor = color;
            ${THREE.ShaderChunk[ "fog_fragment" ]}
        }
    `,
    transparent: true,
    fog: true
})


const setUpEmotes = () => {
    

  
        const emotesParticlesPositions = new Float32Array(emotesPositions.length * 3)
        const emotesRandArray = new Float32Array(emotesPositions.length * 2)

        for (let j = 0; j < emotesPositions.length; ++j) {
            emotesParticlesPositions[j * 3 + 0] = emotesPositions[j].x
            emotesParticlesPositions[j * 3 + 1] = emotesPositions[j].y
            emotesParticlesPositions[j * 3 + 2] = emotesPositions[j].z

            emotesRandArray[j * 2 + 0] = Math.random()
            emotesRandArray[j * 2 + 1] = Math.random()
        }

        const emotesParticlesGeo = new THREE.BufferGeometry()
        emotesParticlesGeo.setAttribute('position', new THREE.BufferAttribute(emotesParticlesPositions, 3))
        emotesParticlesGeo.setAttribute('aRandom', new THREE.BufferAttribute(emotesRandArray, 2))

        //emotesMaterial
        // testMaterial = new THREE.PointsMaterial({color: 'red'})
        emotesParticles = new THREE.Points(
            emotesParticlesGeo,
            emotesMaterial
        )
        scene.add(emotesParticles)

}

// const instantiateEmotes = () =>{

//     //const dummy = new THREE.Object3D()

//     //const emotesMesh1 = new THREE.InstancedMesh(emotesGeometry[emotesNames[0]], emotesMaterials[0], emotesPositions.length )
//     //const emotesMesh2 = new THREE.InstancedMesh(emotesGeometry[emotesNames[1]], emotesMaterials[1], emotesPositions.length )

//     // for ( let i = 0; i <  emotesPositions.length; i ++ ) {
//     //     dummy.position.copy( emotesPositions[i] )
//     //     dummy.lookAt(personPosition)
//     //     const emoteScale = 0.1 + Math.random() * 0.1
//     //     dummy.rotation.set(dummy.rotation.x - 3.14 / 2 + Math.random() * 0.1, 0,  (Math.random() - 0.5) * Math.PI / 4)
//     //     dummy.position.set(
//     //         dummy.position.x,
//     //         dummy.position.y + Math.random() * 2,
//     //         dummy.position.z)

//     //     dummy.scale.set(emoteScale,emoteScale,emoteScale)
//     //     dummy.updateMatrix();
//     // }

//     // //emotesMesh.instanceMatrix.setUsage( THREE.DynamicDrawUsage );

//     // scene.add(emotesMesh)

//     emotesMeshes[emotesNames[0]] = new THREE.Mesh(emotesGeometry[emotesNames[0]], emotesMaterials[0])
//     emotesMeshes[emotesNames[1]] = new THREE.Mesh(emotesGeometry[emotesNames[1]], emotesMaterials[1])

// }
// const animateEmotes = () => {

//     const randomPlace = Math.ceil(Math.random() * emotesPositions.length)

//     emotesMeshes[emotesNames[0]].position.set(emotesPositions[randomPlace])
// }

const myReflectorShader  = {

	uniforms: {

		'color': {
			value: null
		},

		'tDiffuse': {
			value: null
		},

		'uTexture': {
			value: bakeTexture
		},
        'uFloorEdgesTexture':{
            value: reflectiveFloorTexture
        },
		'textureMatrix': {
			value: null
		},

        
        'fogColor':    { type: "c", value: scene.fog.color },
       'fogNear':     { type: "f", value: scene.fog.near },
        'fogFar':      { type: "f", value: scene.fog.far },

        'cameraDistance' : {value: 1000}

	},

	vertexShader: /* glsl */
    `
 
		uniform mat4 textureMatrix;
		varying vec4 vUv;
        varying vec2 myUv;
        varying float vDist;
		#include <logdepthbuf_pars_vertex>
        ${THREE.ShaderChunk[ "common" ]}
        ${THREE.ShaderChunk[ "fog_pars_vertex" ]}
		void main() {
            myUv = vec2(uv.x, 1.0 - uv.y);
			vUv = textureMatrix * vec4( position, 1.0 );

            vDist = -(modelViewMatrix * vec4( position, 1.0 )).z;

            ${THREE.ShaderChunk[ "fog_vertex" ]}
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
			#include <logdepthbuf_vertex>
		}`,

	fragmentShader: /* glsl */`

    
		uniform vec3 color;
        uniform vec3 fogColor;
		uniform sampler2D tDiffuse;
        uniform sampler2D uTexture;
        uniform sampler2D uFloorEdgesTexture;
		varying vec4 vUv;
        varying vec2 myUv;
        varying float vDist;
		#include <logdepthbuf_pars_fragment>

        ${THREE.ShaderChunk[ "common" ]}
        ${THREE.ShaderChunk[ "fog_pars_fragment" ]}

		float blendOverlay( float base, float blend ) {
			return( base < 0.5 ? ( 2.0 * base * blend ) : ( 1.0 - 2.0 * ( 1.0 - base ) * ( 1.0 - blend ) ) );
		}
		vec3 blendOverlay( vec3 base, vec3 blend ) {
			return vec3( blendOverlay( base.r, blend.r ), blendOverlay( base.g, blend.g ), blendOverlay( base.b, blend.b ) );
		}




    
            
		void main() {
			#include <logdepthbuf_fragment>
  

			vec4 base = texture2DProj( tDiffuse, vUv );
            
            //float distToCenter = distance(vec2(0.5,0.32), myUv);
            //gl_FragColor = vec4(distToCenter, distToCenter, distToCenter, 1);

            float reflectionIntensity = 1. - texture(uFloorEdgesTexture, myUv).r;
            vec4 textureColor = texture(uTexture, myUv);

            //gl_FragColor = vec4(intensity,intensity,intensity, 1.);
            vec3 outgoingLight = blendOverlay((base * reflectionIntensity).rgb, textureColor.rgb);


            float nDist = clamp(vDist * 0.015, 0., 1.);

            
            gl_FragColor =  vec4(nDist, nDist, nDist, 1.0);
            gl_FragColor = vec4(mix(outgoingLight, fogColor, nDist), 1.0);
            

            ${THREE.ShaderChunk[ "fog_fragment" ]}
            #include <encodings_fragment>

		}`,

        fog: true
}



const myFloorMaterial  = new ShaderMaterial({

	uniforms: {

		'color': {
			value: null
		},

		'tDiffuse': {
			value: null
		},

		'uTexture': {
			value: bakeTexture
		},
        'uFloorEdgesTexture':{
            value: reflectiveFloorTexture
        },

        
        'fogColor':    { type: "c", value: scene.fog.color },
       'fogNear':     { type: "f", value: scene.fog.near },
        'fogFar':      { type: "f", value: scene.fog.far },

        'cameraDistance' : {value: 1000}

	},

	vertexShader: /* glsl */
    `
		varying vec4 vUv;
        varying vec2 myUv;

        ${THREE.ShaderChunk[ "common" ]}
        ${THREE.ShaderChunk[ "fog_pars_vertex" ]}
		void main() {
            vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
            myUv = vec2(uv.x, 1.0 - uv.y);
            
            ${THREE.ShaderChunk[ "fog_vertex" ]}
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,

	fragmentShader: /* glsl */`

    
		uniform vec3 color;
		uniform sampler2D tDiffuse;
        uniform sampler2D uTexture;
        uniform sampler2D uFloorEdgesTexture;
		varying vec4 vUv;
        varying vec2 myUv;

        ${THREE.ShaderChunk[ "common" ]}
        ${THREE.ShaderChunk[ "fog_pars_fragment" ]}

		float blendOverlay( float base, float blend ) {
			return( base < 0.5 ? ( 2.0 * base * blend ) : ( 1.0 - 2.0 * ( 1.0 - base ) * ( 1.0 - blend ) ) );
		}
		vec3 blendOverlay( vec3 base, vec3 blend ) {
			return vec3( blendOverlay( base.r, blend.r ), blendOverlay( base.g, blend.g ), blendOverlay( base.b, blend.b ) );
		}




    
            
		void main() {
			#include <logdepthbuf_fragment>
  
            
            //float distToCenter = distance(vec2(0.5,0.32), myUv);
            //gl_FragColor = vec4(distToCenter, distToCenter, distToCenter, 1);

            float reflectionIntensity = 1. - texture(uFloorEdgesTexture, myUv).r;
            vec3 textureColor = texture(uTexture, myUv).rgb;

            //gl_FragColor = vec4(intensity,intensity,intensity, 1.);
            
            //vec3 outgoingLight = vec3(reflectionIntensity, reflectionIntensity, reflectionIntensity);

            
            gl_FragColor = vec4(textureColor, 0.5);
            

            ${THREE.ShaderChunk[ "fog_fragment" ]}

		}`,

        fog: true,
        transparent: true,
        blending: THREE.NormalBlending
})

let groundMirror = null;


fbxLoader.load(
    'mirror_plane.fbx',
    (object) =>
    {

        const child = object.children[0]

        child.visible = false;
        const geometry = child.geometry//new THREE.CircleGeometry(20, 16)
        
          
        groundMirror = new THREE.Mesh(geometry, myFloorMaterial)

        


        // groundMirror = new Reflector( geometry, {
        //     clipBias: 0.003,
        //     textureWidth: window.innerWidth * window.devicePixelRatio,
        //     textureHeight: window.innerHeight * window.devicePixelRatio,
        //     //color: 0x777777,
        //     color: 0x1A1E24,
        //     shader: myReflectorShader,
        // } );




        groundMirror.position.y = -0.01
        groundMirror.rotateX(-Math.PI / 2)
        
        scene.add( groundMirror )
        // ticketRenders['ticket2'] = setupTicketRenderer(object.children[0], 'ticket2', companyMat)
    }
)

const headTexture = textureLoader.load('sam_bakker_texture2.jpg')
headTexture.flipY = false
headTexture.encoding = THREE.LinearEncoding
const headMaterial = new THREE.MeshBasicMaterial({map: headTexture, side: THREE.DoubleSide})
const suitTexture = textureLoader.load('suit_texture.jpg')
suitTexture.flipY = false
const suitMaterial = new THREE.MeshBasicMaterial({map: suitTexture, side: THREE.DoubleSide})


const personMatcapTexture = textureLoader.load('silver_matcap.jpg')
const personMatcapMat = new THREE.MeshMatcapMaterial({matcap: personMatcapTexture, side: THREE.DoubleSide})
//const personMatcapMat = new THREE.MeshStandardMaterial({color: '#0A0C0E', roughness: 0.25})


// const speakerCubemap = new THREE.CubeTextureLoader()
// 	.setPath( 'cubeMaps/speaker/' )
// 	.load( [
// 		'px.png',
// 		'nx.png',
// 		'py.png',
// 		'ny.png',
// 		'pz.png',
// 		'nz.png'
// 	] );
// personMatcapMat.envMap = speakerCubemap
/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}


window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)


    renderer.setPixelRatio(getPixelRatio())


    // Sections heights
    updateSectionsHeights()
    console.log('totalScrollLength', totalScrollLength)
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 100)

gui.add(camera, 'fov').min(40).max(90).onChange(()=>{
    camera.updateProjectionMatrix()
})
camera.position.x = 0
camera.position.y = 12
camera.position.z = 10

scene.add(camera)

// Controls
//const controls = new OrbitControls(camera, canvas)
//controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
    powerPreference: 'high-performance'
})
renderer.setSize(sizes.width, sizes.height)

let pixelRatio = getPixelRatio()
pixelRatio = 2
renderer.setPixelRatio(pixelRatio)

renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1;


//scene.background.convertSRGBToLinear()


const logoMat = new THREE.ShaderMaterial({

    uniforms: {
        u_color1 : {value: new THREE.Color('red')},
        u_color2 : {value: new THREE.Color('blue')},
        u_color3 : {value: new THREE.Color('cyan')},

        fogColor:    { type: "c", value: scene.fog.color },
        fogNear:     { type: "f", value: scene.fog.near },
        fogFar:      { type: "f", value: scene.fog.far }
	},

	vertexShader: `
        ${THREE.ShaderChunk[ "common" ]}
        ${THREE.ShaderChunk[ "fog_pars_vertex" ]}
        
        varying vec2 vUv;
        void main() {
            vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
            //vUv = position.xz;
            vUv = uv;
            ${THREE.ShaderChunk[ "fog_vertex" ]}
            vec4 modelPosition = modelMatrix * vec4( position, 1.0 );
            gl_Position = projectionMatrix * viewMatrix * modelPosition;
        }
    `,

	fragmentShader: `

    uniform vec3 u_color1;
    uniform vec3 u_color2;
    uniform vec3 u_color3;
    
    varying vec2 vUv;
    ${THREE.ShaderChunk[ "common" ]}
    ${THREE.ShaderChunk[ "fog_pars_fragment" ]}

    void main() {
        float h = 0.5;
        vec3 outgoingLight = mix(mix(u_color1, u_color2, vUv.x/h), mix(u_color2, u_color3, (vUv.x - h)/(1.0 - h)), step(h, vUv.x));
        gl_FragColor = vec4(outgoingLight, 1.0);
        ${THREE.ShaderChunk[ "fog_fragment" ]}

}
  `,

    fog: true
})

gui.addColor(debugObject, 'clearColor').onChange(()=>{
    scene.background = new THREE.Color(debugObject.clearColor)
    scene.background.convertSRGBToLinear()
})

// const object = new THREE.Mesh(
//     new THREE.BoxGeometry(3,0.5, 2),
//     new THREE.MeshBasicMaterial({color: 0xFF0000})
// )

// object.position.set(0, 0.35, 0)
// scene.add(object);




//renderer.toneMapping = THREE.ReinhardToneMapping


const composer = new EffectComposer( renderer );
const renderPass = new RenderPass( scene, camera );

const params = {
    bloomThreshold: 0.12,
    bloomStrength: 0.582,
    bloomRadius: 1
};



//  resolution, strength, radius, threshold
const unrealBloomPass = new UnrealBloomPass(
    new THREE.Vector2(
        sizes.width,
        sizes.height), 
        params.bloomStrength, 
        params.bloomRadius, 
        params.bloomThreshold);



const gammaCorrectionPass = new ShaderPass(GammaCorrectionShader);





const bloomFolder = gui.addFolder('Bloom')
bloomFolder.add(unrealBloomPass, 'enabled')
bloomFolder.add(params, 'bloomThreshold').min(0).max(1).onChange( ()=>{
    unrealBloomPass.threshold = params.bloomThreshold
})
bloomFolder.add(params, 'bloomStrength').min(0).max(1).onChange( ()=>{
    unrealBloomPass.strength = params.bloomStrength
})
bloomFolder.add(params, 'bloomRadius').min(0).max(1).onChange( ()=>{
    unrealBloomPass.radius = params.bloomRadius
})




const hblur = new ShaderPass( HorizontalBlurShader)
const vblur = new ShaderPass( VerticalBlurShader );


vblur.enabled = false
hblur.enabled = false

const are_you_text = document.getElementById("are_you_text")
const sam_bakker_text = document.getElementById("sam_bakker_text")

are_you_text.addEventListener('mouseenter', (event) => {
    vblur.enabled = true
    hblur.enabled = true
});
are_you_text.addEventListener('mouseleave', (event) => {
    vblur.enabled = false
    hblur.enabled = false
});
sam_bakker_text.addEventListener('mouseenter', (event) => {
    vblur.enabled = true
    hblur.enabled = true
});
sam_bakker_text.addEventListener('mouseleave', (event) => {
    vblur.enabled = false
    hblur.enabled = false
});



const ChromaticAberrationShader = {
    uniforms:
    {
        'time': {value: 0.0},
        'tDiffuse': { value: null },
        'uVelocity': {value: 8.0},
        'uSize': {value: new THREE.Vector2(sizes.width, sizes.height)}
    },
    vertexShader: `
        varying vec2 vUv;
        void main()
        {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);

        }
    `,
    fragmentShader: chrommaticAberrationFragmentShader
}

const chromaticAberrationShaderPass = new ShaderPass(ChromaticAberrationShader);
gui.add(chromaticAberrationShaderPass, 'enabled').name('chromatic aberration')

// composer.addPass( ssrPass );


// const renderTargetParameters = {
// 	minFilter: THREE.LinearFilter,
// 	magFilter: THREE.LinearFilter,
// 	stencilBuffer: false
// };

// // save pass
// const savePass = new SavePass(
// 	new THREE.WebGLRenderTarget(
// 		sizes.width,
// 		sizes.height,
// 		renderTargetParameters
// 	)
// );

// const blendPass = new ShaderPass(BlendShader, "tDiffuse1");
// blendPass.uniforms["tDiffuse2"].value = savePass.renderTarget.texture;
// blendPass.uniforms["mixRatio"].value = 0.4;

// // output pass
// const outputPass = new ShaderPass(CopyShader);
// outputPass.renderToScreen = true;




// composer.addPass(blendPass);
// composer.addPass(savePass);
// composer.addPass(outputPass);


composer.addPass( renderPass )
composer.addPass( hblur )
composer.addPass( vblur )
composer.addPass( unrealBloomPass )
composer.addPass( chromaticAberrationShaderPass )
composer.addPass(gammaCorrectionPass );


gammaCorrectionPass.enabled = false
unrealBloomPass.enabled = true

gui.add(gammaCorrectionPass, 'enabled').name('Gamma Correction Pass')



// renderer.outputEncoding = THREE.LinearEncoding
// renderer.outputEncoding = THREE.sRGBEncoding
// 
// 
// unrealBloomPass.enabled = false

//composer.addPass( gammaCorrectionPass )



const cameraPositions = [
    new THREE.Vector3().copy(camera.position),
    new THREE.Vector3(0, 5, 10),
    new THREE.Vector3(0, 2, 24),
    new THREE.Vector3(0, 6, 40),
    new THREE.Vector3(20, 3, 20),
    new THREE.Vector3(9.24, 1.37, 4.86),
    new THREE.Vector3(6, 1.37, 4.86),
    new THREE.Vector3(12.24, 1.37, 4.86),


    new THREE.Vector3(100, 80, 4.86),
]

// const cameraPositions = [
//     new THREE.Vector3().copy(camera.position),
//     new THREE.Vector3(0, 5, 10),
//     new THREE.Vector3(0, 2, 24),
//     new THREE.Vector3(0, 6, 40),
//     new THREE.Vector3(12, 3, 20),
//     new THREE.Vector3(4, 1.37, 12),
//     new THREE.Vector3(3, 2, 10),
//     new THREE.Vector3(12.24, 1.37, 4.86),


//     new THREE.Vector3(100, 80, 4.86),
// ]


// 0.17 -> first section
// 0.417 -> second section


const cameraLookAtPositions = [
    new THREE.Vector3(0, camera.position.y, -10),
    new THREE.Vector3(0, camera.position.y, -10),

    new THREE.Vector3(0, 5, -6),

    new THREE.Vector3(0, 1.5, 6),


]
const lookAtEasing = BezierEasing(0,.64,.2,1)//BezierEasing(0.00, 0.64, 0.26, 0.86)

/**
 * Camera easing 
 */

// points
// 0.25 -> 0.134
// 0.5 -> 0.417

// const cameraTimingCurve = new THREE.CubicBezierCurve(
//     new THREE.Vector2(0, 0),
// 	new THREE.Vector2(0.25, 0.134),
// 	new THREE.Vector2( 0.5 ,  0.417 ),
//     new THREE.Vector2(0.745, 1 - 0.255),
//     new THREE.Vector2(1, 1),
// )

function getCameraTiming(from0To1) {
    return findBezierCurveYfromX(from0To1 * 100) * 0.01
}

const cameraPositionsDebug = {
    progress: 0
}

let cameraPosN = 0


/**
 * 
 * Moving camera along spline 
 */


let curve = new THREE.CatmullRomCurve3(cameraPositions);
let curveLookAt = new THREE.CatmullRomCurve3(cameraLookAtPositions);

console.log('total length', curve.getLength());

// const points0 = curve.getPoints( 128 );
// const curveGeo0 = new THREE.BufferGeometry().setFromPoints( points0 );
// const curveMat0 = new THREE.LineBasicMaterial( { color: 0x00ffff } );
// const curve0Obj = new THREE.Line( curveGeo0, curveMat0 );
// scene.add(curve0Obj);


// const points1 = curveLookAt.getPoints( 128 );
// const curveGeo1 = new THREE.BufferGeometry().setFromPoints( points1 );
// const curveMat1 = new THREE.LineBasicMaterial( { color: 0x0000ff } );
// const curve1Obj = new THREE.Line( curveGeo1, curveMat1 );
// scene.add(curve1Obj);

function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}    


const sections = [
    'header',
    'are_you',
    'sam_bakker'
]
let sectionsHeights = new Array(sections.length)
let heightSum = 0
let totalScrollLength = 0

function updateSectionsHeights() {
    heightSum = 0

    for (let j = 0; j < sections.length; ++j) {
        heightSum += document.getElementById(sections[j]).offsetHeight
        sectionsHeights[j] = heightSum
      
        // let elemDiv = document.createElement('div');
        // elemDiv.style.cssText = `left:0;top:${heightSum}px;position:absolute;width:100%;height:1px;z-index:100;background:#f00;`;
        // document.getElementById("page_content").appendChild(elemDiv);
    }
   // totalScrollLength = heightSum - document.getElementById(sections[sections.length - 1]).offsetHeight / 2
    totalScrollLength = heightSum + document.getElementById('old_model_1').offsetHeight
}
docReady(()=>
{
    updateSectionsHeights()
    if (sizes.width < 800) {
        chromaticAberrationShaderPass.enabled = false
    }

     top = getPos(document.getElementById("tickets")).y
     bottom = top + document.getElementById("ticket1").offsetHeight


     sellDeliverScaleSectionPos = getPos(document.getElementById("sell_deliver_scale")).y
     ticketsOnSaleSectionPos = getPos(document.getElementById("tickets")).y

})

let currentSectionId = 0
let cameraDesiredPosition = null
let lookAtObjectDesiredPosition = null

function lerp(start, end, amt) {
    return (1 - amt) * start + amt * end
}

let myProgress = 0.25





/*

----------------------
*/


// instantiate a loader
const loader = new SVGLoader()

let cameraTimingPoints = null

function binarySearch(arr, val, start, end) {
    // edge case: value of smaller than min or larger than max
    if(arr[0].x >= val) return 0;
    if(arr[arr.length - 1].x <= val) return arr.length - 1;
    
    while (start <= end) {
        let mid = Math.floor((end + start) / 2);
        
        // value is in interval from previous to current element
        if (mid - 1 <= 0) {
            return 0
        }
        if(val >= arr[mid - 1].x && val <= arr[mid].x) {
            return Math.abs(val - arr[mid - 1].x) < Math.abs(val - arr[mid].x) ? mid - 1 : mid;
        }
        else {
            if(arr[mid].x < val) {
                start = mid + 1;
            } 
            else {
                end = mid - 1;
            }
        }
    }
    return -1;
}

function findBezierCurveYfromX(x) {

    if (cameraTimingPoints == null) {
        return x * 0.01
    }
    let j = binarySearch(cameraTimingPoints, x, 0, cameraTimingPoints.length)
    return Math.max(0, cameraTimingPoints[j].y)
}

// load a SVG resource
loader.load(
	// resource URL
	'svg_curve2.svg',
	// called when the resource is loaded
	function ( data ) {

		const paths = data.paths;
		const group = new THREE.Group()

        const curves = paths[0]['currentPath']['curves']

		for ( let i = 0; i < curves.length; i ++ ) {
            // const points = curves[i].getPoints( 16 );
            // // const geometry = new THREE.BufferGeometry().setFromPoints( points );
            // // const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
            // // const lineObj = new THREE.Line( geometry, material )
 
            // // group.add(lineObj)


		}

        const curvePath = new THREE.CurvePath()
        for (let j = 0; j < curves.length; ++j) {
            curvePath.add(curves[j])
        }

        myProgress = myProgress * 100

        cameraTimingPoints = curvePath.getPoints(256)


        group.scale.set(0.01, 0.01, 0.01)
        group.position.x = -6
        group.position.y = 0
        group.position.z = -6

        camera.add(group)


	}
);








/*

----------------------
*/


const lerpKeyFrames = (progress, keyframes) => {
    let arrIndex = Math.floor(progress * keyframes.length)
    console.log(arrIndex);
    const lerpFactor = Math.abs((progress * keyframes.length) % 1)

    
    if (arrIndex < 0) {
        arrIndex = 0
    }
    console.log('lerpBetweenKeyFrames', 
    'progress:', progress, 
    'arrIndex:', arrIndex,
    'lerpFactor:', lerpFactor, 
    'between:', keyframes[arrIndex],
    'and', keyframes[arrIndex + 1], '->', lerp(keyframes[arrIndex], keyframes[arrIndex + 1], lerpFactor))
    return lerp(keyframes[arrIndex], keyframes[arrIndex + 1], lerpFactor)
}
// const cameraFovKeyFrames = [
//     45, 45, 75, 75, 45, 45, 45, 45, 45, 45
// ]
const updateCameraPosition = (progress) =>{
    if (progress > 1) {
        return
    }

    const cameraPos = curve.getPointAt(getCameraTiming(progress))
  
    const lookAtObjectPosition = curveLookAt.getPointAt(lookAtEasing(progress))

    cameraDesiredPosition = new THREE.Vector3(cameraPos.x, cameraPos.y, cameraPos.z)

    cameraLookAtPosition = lookAtObjectPosition
    // cameraLookAtObject.position.x = lookAtObjectPosition.x
    // cameraLookAtObject.position.y = lookAtObjectPosition.y
    // cameraLookAtObject.position.z = lookAtObjectPosition.z
    

    
    // camera.fov = lerpKeyFrames(progress, cameraFovKeyFrames)
    // camera.updateProjectionMatrix()

    camera.lookAt(cameraLookAtPosition)

    // cameraPosN = Math.floor(progress)
    // if (cameraPosN + 1>= cameraPositions.length) {
    //     return
    // }
    // const lerpFactor = progress - cameraPosN

    // camera.position.lerpVectors(
    //     points[cameraPosN],
    //     points[cameraPosN + 1],
    //     lerpFactor)
    

    //const cameraAngle = THREE.MathUtils.lerp(cameraRotationsY[cameraPosN], cameraRotationsY[cameraPosN + 1], progress % 1);
    //console.log('angle', progress % 1, cameraAngle, 'between', cameraRotationsY[cameraPosN], cameraRotationsY[cameraPosN + 1])
    //camera.rotation.y = (cameraAngle / 180) * Math.PI


}





gui.add(cameraPositionsDebug, 'progress').min(0).max(1).onChange(()=>{

    updateCameraPosition(cameraPositionsDebug.progress)

})

/**
 * Scroll
 */


 let scrollY = window.scrollY
 let scrollFrom0To1 = 0


const topBar = document.getElementById("top_bar")
const topBuyButton = document.getElementById("buy_tickets_top")

let scrolledTopBar = false

const countdownEl = document.getElementById("countdown")

let sellDeliverScaleSectionPos = getPos(document.getElementById("sell_deliver_scale")).y
let ticketsOnSaleSectionPos = getPos(document.getElementById("tickets")).y

function updateOnScroll() {

    if (sizes.width > 800) {
        /* only on desktop */
        if (16 < scrollY && scrollY < heightSum)  {
            if (!scrolledTopBar) {
                scrolledTopBar = true
                topBar.classList.add("scrolled");
            }
        } else {
            topBar.classList.remove("scrolled");
            scrolledTopBar = false
        }
    } else {
        if (scrollY > totalScrollLength)  {
            topBuyButton.classList.add("scrolled");
        } else {
            topBuyButton.classList.remove("scrolled");
        }
    }


    
    //scrollY = args.scroll.y
    
    if (scrollY > sectionsHeights[currentSectionId]) {
        console.log('scrolled down')
        currentSectionId += 1

    } else if (currentSectionId > 0 && scrollY < sectionsHeights[currentSectionId - 1]) {
        console.log('scrolled up')
        currentSectionId -= 1
    }


    //scrollY = window.scrollY

    scrollFrom0To1 = scrollY / totalScrollLength

    updateCameraPosition(scrollFrom0To1)


    /* countdown timer */


    if (window.innerWidth >= 800) {


        if (scrollY >= sellDeliverScaleSectionPos && scrollY < ticketsOnSaleSectionPos) {
            countdownEl.classList.remove("dark")
        } 
        if (scrollY <= sellDeliverScaleSectionPos || scrollY >= ticketsOnSaleSectionPos) {
            countdownEl.classList.add("dark")
        }
    }


    // if (scrollFrom0To1 == 4) {
    //     canvas.style.position = "absolute"
    // }
}

// let smoothScroll = {
//     enabled: false
// }

// gui.add(smoothScroll, 'enabled').name('smooth scroll')


window.addEventListener('scroll', ()=>{

        scrollY = window.scrollY
        updateOnScroll()

})

// const onScroll = (status) => {
//     if (smoothScroll.enabled) {
//         scrollY = status.offset.y
//         updateOnScroll()
//     }
// }

// let scrollBar = Scrollbar.init(document.querySelector('#page_content'), {damping: 0.1})
// scrollBar.addListener(onScroll)






/**
 * Particles
 */

const particlesN = 500
const particlesPositions = new Float32Array(particlesN * 3)
for (let j = 0; j < particlesN; ++j) {
    particlesPositions[j * 3 + 0] = (Math.random() - 0.5) * 30;
    particlesPositions[j * 3 + 1] = Math.random() * 20;
    particlesPositions[j * 3 + 2] = Math.random() * 30 - 5;
}

const particlesGeometry = new THREE.BufferGeometry()
particlesGeometry.setAttribute('position', new THREE.BufferAttribute(particlesPositions, 3))


const particlesMaterial = new THREE.ShaderMaterial({
    uniforms: {
        uPixelRatio: {value: getPixelRatio()},
        uSize: {value: 50},
        uTime: {value: 0},

        fogColor:    { type: "c", value: scene.fog.color },
        fogNear:     { type: "f", value: scene.fog.near },
        fogFar:      { type: "f", value: scene.fog.far }
    },
    transparent: true,
    blending: THREE.AdditiveBlending,
    depthWrite: false,
    vertexShader: 
    `
    ${THREE.ShaderChunk[ "common" ]}
    ${THREE.ShaderChunk[ "fog_pars_vertex" ]}
    uniform float uPixelRatio;
    uniform float uSize;
    uniform float uTime;


    void main() {

        vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );

        vec4 modelPosition = modelMatrix * vec4(position, 1.0);
        modelPosition.y += sin(uTime + modelPosition.x * 100.0) * 0.2;

        vec4 viewPosition = viewMatrix * modelPosition;
        vec4 projectionPosition = projectionMatrix * viewPosition;

        ${THREE.ShaderChunk[ "fog_vertex" ]}

        gl_Position = projectionPosition;
        gl_PointSize = uSize * uPixelRatio;
        gl_PointSize *= (1.0 / -viewPosition.z);
    }
    `,

    fragmentShader: 
    `
        ${THREE.ShaderChunk[ "common" ]}
        ${THREE.ShaderChunk[ "fog_pars_fragment" ]}
    void main() {
        float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
        gl_FragColor = vec4(1.0, 1.0, 1.0, 0.05 / distanceToCenter - 0.05 * 2.0);
        ${THREE.ShaderChunk[ "fog_fragment" ]}

    

    }


   
    `,
    transparent: true,
    fog: true
})

// const particles = new THREE.Points(
//     particlesGeometry,
//     new THREE.PointsMaterial({
//         color: 0xffffff,
//         size: 0.5,
//         alphaMap: particlesAlpha,
//         sizeAttenuation: true,
//         transparent: true
//     })
// )

const particles = new THREE.Points(
    particlesGeometry,
    particlesMaterial
)
scene.add(particles)


// void main()
// {
//     float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
//     float strength = 0.05 / distanceToCenter - 0.1;

//     gl_FragColor = vec4(1.0, 1.0, 1.0, strength);
// }
/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0


let screenHeight = 2 * camera.position.z * Math.tan(camera.fov / 360 * 2 * Math.PI / 2)
screenHeight = 4

// const cameraLookAtObject = new THREE.Mesh(
//     new THREE.SphereGeometry(0.1),
//     new THREE.MeshBasicMaterial({color: 'green'})
// )
// scene.add(cameraLookAtObject)


let cameraLookAtPosition = new THREE.Vector3(0, camera.position.y, 0);
//let cameraLookAtPosition = cameraLookAtObject.position;

let cameraLerpFactor = 0.1

let velocityValue = 0
let desiredVelocityValue = 0

let prevScroll = 0

function doRenderStuff() {

    elapsedTime = clock.getElapsedTime()
    
    
    //console.log('render scene', elapsedTime)

    if (emotesParticles) {
        emotesParticles.material.uniforms['uTime'].value = elapsedTime;
    }
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    if (cameraDesiredPosition != null) {
        camera.position.lerpVectors(camera.position, cameraDesiredPosition, cameraLerpFactor)

    }
 
    const scrollNow = scrollY
    const deltaScroll = scrollNow - prevScroll
    prevScroll = scrollNow
    
    chromaticAberrationShaderPass.uniforms['time'].value = elapsedTime
    desiredVelocityValue = Math.max(0.2, (Math.abs(deltaScroll) / 20)) * 10
    velocityValue = lerp(velocityValue, desiredVelocityValue, 0.1)
    chromaticAberrationShaderPass.uniforms['uVelocity'].value = velocityValue
 

    //ChromaticAberrationShader.uniforms.uVelocity.value = Math.abs(deltaScroll);




    camera.lookAt(cameraLookAtPosition)

    //camera.position.y = -scrollY / sizes.height * screenHeight

    // sphereA.position.set(sphereA.position.x, 
    //     (Math.sin(elapsedTime) + 1.0) / 2.0, 
    //     sphereA.position.z)


    //firefliesMaterial.uniforms.uTime.value = elapsedTime;
    // Update controls
    //controls.update()

    stats.update(deltaTime);
    
    // // Render
    // if(Math.floor(elapsedTime) % 2 == 0) {
    //     stage.visible = false

    //     cubeCamera.update( renderer, scene )

    //     stage.visible = true
    // }


    composer.render();
    //renderer.render(scene, camera)




    // Call tick again on the next frame

}

/* ticket scene
*/



let loadedTicketTexture1 = false
// let loadedTicketTexture2 = false

const attendeeTexture = textureLoader.load('ticket/attendee_color_top.jpg', ()=>{
    loadedTicketTexture1 = true,
    attendeeTicketMat.needsUpdate = true
})
const attendeeCutout = textureLoader.load('ticket/attendee_cutout.jpg', ()=>{
    attendeeTicketMatFoil.needsUpdate = true
})
const attendeeAlpha = textureLoader.load('ticket/attendee_alpha.jpg', ()=>{
    attendeeTicketMat.needsUpdate = true
})
const ticketMatcapTexture = textureLoader.load('irridicent_matcap.jpg', ()=>{
    attendeeTicketMatFoil.needsUpdate = true
})
// const attendeeMat = new THREE.MeshBasicMaterial({map: null})


const attendeeTicketMat = new THREE.MeshStandardMaterial({
    map: attendeeTexture,
    alphaMap: attendeeAlpha,
    transparent: true 
})
const attendeeTicketMatFoil = new THREE.MeshMatcapMaterial({
    alphaMap: attendeeCutout,
    matcap: ticketMatcapTexture,
    transparent: true 
})

// fileLoader.setResponseType('arraybuffer')
// fileLoader.load(
//     'wave2.vertexpos',
//     (data)=>{
//         const ticketVertexPositionsArray = new Float32Array(data)


//         //var my_data = new Uint8Array(my_data);


//         var side = 256
//         var amount = side * side
//         var my_data = new Float32Array(amount * 4)

//         let k = 0;
//         let n = 1;
//         for (let x = 0; x < side; ++x ) {
//             for (let y = 0; y < side; ++y) {


//                 const stride = k * 4
                
//                 let x = 1
//                 let y = 0


//                 if (n <= ticketVertexPositionsArray.length) {
//                     x = ticketVertexPositionsArray[n - 1]
//                     y = ticketVertexPositionsArray[n]
//                 }
//                 //my_data[ stride ] = ticketVertexPositionsArray[n - 1]
//                 my_data[ stride ] = x
//                 my_data[ stride + 1 ] = y
                
//                 my_data[ stride + 2 ] = 1
//                 my_data[ stride + 3 ] = 1
    
//                 n += 2
//                 k += 1
//             }
//         }

//         dataTexture = new THREE.DataTexture(my_data, side, side, THREE.RGBAFormat, THREE.FloatType);

//         dataTexture.needsUpdate = true
//         dataTexture.flipY = true
//         attendeeMat.uniforms.u_TicketVertexPositions.value = dataTexture
//         dataTexture.needsUpdate = true
//         console.log(dataTexture)
        
//         var planeGeo = new THREE.PlaneBufferGeometry(8, 8);
//         var planeMat = new THREE.MeshBasicMaterial({ map: dataTexture});
//         var testPlane = new THREE.Mesh(planeGeo, planeMat);
//         testPlane.position.set(0, 6, 5)
//         scene.add(testPlane);


//         //ticketVertexPositions = new THREE.DataTexture(my_data, 64, 64, THREE.LuminanceFormat, THREE.UnsignedByteType)
//         //console.log(ticketVertexPositions)
//         //ticketVertexPositions.needsUpdate = true

//     },
//     ( xhr ) => {
//         console.log( (xhr.loaded / xhr.total * 100) + '% loaded' );
//     },
//     // onError callback
//     ( err ) =>{
//         console.error( 'An error happened' );
//     }
// );







// const companyTexture = textureLoader.load('company_color.png', ()=>{
//     loadedTicketTexture2 = true
// })
// const companyMat = new THREE.MeshBasicMaterial({map: companyTexture, side:THREE.DoubleSide})

const ticketsRotation = {x:1.25, y:-0.376, z:0}
const ticketsPosition = {x:0, y:0, z:0}
gui.add(ticketsRotation, 'x').name('tickets rotation x').min(-Math.PI * 2).max(Math.PI * 2).onChange(()=>{
    ticketRenders['ticket1'][3].rotation.x = ticketsRotation.x
    renderTickets()
})
gui.add(ticketsRotation, 'y').name('tickets rotation y').min(-Math.PI * 2).max(Math.PI * 2).onChange(()=>{
    ticketRenders['ticket1'][3].rotation.y = ticketsRotation.y
    renderTickets()
})
gui.add(ticketsRotation, 'z').name('tickets rotation z').min(-Math.PI * 2).max(Math.PI * 2).onChange(()=>{
    ticketRenders['ticket1'][3].rotation.z = ticketsRotation.z
    renderTickets()
})
gui.add(ticketsPosition, 'x').name('tickets porition x').min(-1).max(1).onChange(()=>{
    ticketRenders['ticket1'][3].position.x = ticketsPosition.x
    renderTickets()
})
if (!(window.location.hash === '#debug')) {

    gui.hide();
    statsDom.style.display="none"


}


document.getElementById('ticket1').style.height = document.getElementById('ticket1').offsetWidth + 'px';
// document.getElementById('ticket2').style.height = document.getElementById('ticket1').offsetWidth + 'px';


function setupTicketRenderer(plane_, canvas_id, mats) {
    const ticketCanvas = document.getElementById(canvas_id)
    const ticketRenderer = new THREE.WebGLRenderer({
        canvas: ticketCanvas,
        alpha: true,
        antialias: true,
        powerPreference: 'high-performance'
    })

    ticketRenderer.setSize(ticketCanvas.clientWidth, ticketCanvas.clientHeight)
    ticketRenderer.setPixelRatio(getPixelRatio())
    const ticketScene = new THREE.Scene()

    const ticketCamera = new THREE.PerspectiveCamera(30, ticketCanvas.clientWidth /  ticketCanvas.clientHeight, 0.1, 100)

    ticketCamera.position.x = 0
    ticketCamera.position.y = 0
    ticketCamera.position.z = 5
    ticketCamera.lookAt(new THREE.Vector3())

    const ticket = new THREE.Group()
    ticketScene.add(ticket)

    const aLight0 = new THREE.AmbientLight(0xffffff, 0.1)
    const aLight = new THREE.PointLight(0xffffff,3, 5)
    aLight.position.set(0.5, 1, 1)
    const lightHelper = new THREE.PointLightHelper(aLight);
    
    ticketScene.add(aLight0)
    ticketScene.add(aLight)
    //ticketScene.add(lightHelper)


    //const mat2 = new THREE.MeshBasicMaterial({ map: dataTexture});
    // const testPlane = new THREE.Mesh(new THREE.PlaneGeometry(2, 2, 32, 32), mat)
    // //testPlane.position.set(0, 0.5, 2)
    // testPlane.rotation.x = -3.14 * 0.25
    // ticketScene.add(testPlane);

    // gui.add(ticketCamera.position, 'x').min(-1).max(1)
    // gui.add(ticketCamera.position, 'y').min(-1).max(1)
    // gui.add(ticketCamera.position, 'z').min(-1).max(1)
    // gui.add(ticketCamera.rotation, 'x').min(-1).max(1)
    // gui.add(ticketCamera.rotation, 'y').min(-1).max(1)
    // gui.add(ticketCamera.rotation, 'z').min(-1).max(1)

    for (var mi = 0; mi < mats.length; ++mi) {
        const plane1 = new THREE.Mesh(plane_.geometry, mats[mi])
        plane1.position.set(0, 0.01 * mi, 0)
        plane1.scale.set(0.1,0.1,0.1)
        plane1.material.renderOrder = mi
        ticket.add(plane1)
    }


    //plane.material = matcapMaterial

    //plane.material.needsUpdate = true

   

    // const layer2 = new THREE.Mesh(plane_.geometry, new THREE.MeshBasicMaterial({color: 'red'}))
    // layer2.rotation.copy(plane_.rotation)
    // layer2.position.set(0, 0.0001, -0.05)
    // layer2.material.renderOrder = 10
    //ticket.add(layer2)

    let scale = 0.15

    
    ticket.scale.set(scale, scale, scale)
    ticket.rotation.x = ticketsRotation.x
    ticket.rotation.y = ticketsRotation.y
    ticket.rotation.z = ticketsRotation.z
    ticketCamera.lookAt(ticket.position)
    


    return [ticketRenderer,ticketScene, ticketCamera, ticket]
}

let ticketRenders = {
    'ticket1': null,
    // 'ticket2': null
}

let ticketDesiredPositions = {
    'ticket1': new THREE.Vector3()
}

fbxLoader.load(
    'ticket_plane5.fbx',
    (object) =>
    {

        ticketRenders['ticket1'] = setupTicketRenderer(object.children[0], 'ticket1', [attendeeTicketMatFoil, attendeeTicketMat])
        // ticketRenders['ticket2'] = setupTicketRenderer(object.children[0], 'ticket2', companyMat)
    }
)


function renderTickets() {
    //console.log('renderTickets(), time:' + clock.getElapsedTime())

    // ticketRenders['ticket1'][3].rotation.z = Math.sin(mouse.x * Math.PI)

    

    ticketRenders['ticket1'][3].position.lerpVectors(ticketRenders['ticket1'][3].position, ticketDesiredPositions['ticket1'], 0.1 )
    ticketRenders['ticket1'][2].lookAt(ticketRenders['ticket1'][3].position)

    ticketRenders['ticket1'][0].render(ticketRenders['ticket1'][1], ticketRenders['ticket1'][2])

    //console.log('u_time', attendeeMat.uniforms.u_time.value % 1)


    // ticketRenders['ticket2'][0].render(ticketRenders['ticket2'][1], ticketRenders['ticket2'][2])

}


// window.addEventListener('touchmove', function(e) {
//     scrollY = window.scrollY
//     ticketDesiredPositions['ticket'].x = (e.touches[0].screenX / sizes.width - 0.5) * 2
// })

// window.addEventListener('scroll', ()=>{
//     scrollY = window.scrollY
//     ticketDesiredPositions['ticket'].y = -((scrollY / sizes.docHeight)) * 6

// })

/* end ticket scene
*/

function getPos(el) {
    // yay readability
    for (var lx=0, ly=0;
         el != null;
         lx += el.offsetLeft, ly += el.offsetTop, el = el.offsetParent);
    return {x: lx,y: ly};
}

const mouseDebug = document.getElementById("mousedebug")
const mouse = {
    x: 0,
    y: 0
}
document.addEventListener('mousemove', (event) => {
    mouse.x = event.clientX / sizes.width
    mouse.y = -event.clientY / sizes.height
    mouseDebug.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;

    ticketDesiredPositions['ticket1'].x = (mouse.x -0.5) * 2
    ticketDesiredPositions['ticket1'].y = (mouse.y -0.5)

})

let top = getPos(document.getElementById("tickets")).y
let bottom = top + document.getElementById("ticket1").offsetHeight


let ticketsRendered = false
let elapsedTime = 0


//let scrollOffset = 0;

const tick = () =>
{
    //     window.scroll({top: scrollOffset})

    // scrollOffset += 3;
    elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime
    stats.update(deltaTime)

    let isDesktop = sizes.width >= 1024
    isDesktop = true
    
    if (isDesktop) {

        if (scrollY <= totalScrollLength ) {
            doRenderStuff()
        }


        // console.log(top, bottom, scrollY, scrollY + sizes.height)
        // console.log(scrollY >= top, bottom <= scrollY + sizes.height)

        const ticketsVisible = !(scrollY > bottom || scrollY + sizes.height <= top)

        if (!ticketsRendered && ticketsVisible) {

            if (loadedTicketTexture1 && ticketRenders['ticket1']) {
                //ticketsRendered = true
                //console.log('ticketsVisible')
                renderTickets()
            }

        }

    }
    window.requestAnimationFrame(tick)
}

tick()
